import { Facebook, Instagram, ArrowUp } from "lucide-react";

const footerLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Flota", href: "#flota" },
  { label: "Servicios", href: "#servicios" },
  { label: "Educativo", href: "#estudiantil" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Contacto", href: "#contacto" },
];

export default function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-[#080f1c] border-t border-white/5" data-testid="footer-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
          <img src="/assets/logo-silueta.svg" alt="Puerto Deseado Turismo" className="h-56 w-auto mb-4" />
            <p className="text-gray-400 font-body text-sm leading-relaxed max-w-xs">
              Mas de 25 anos brindando soluciones de transporte turistico con seguridad, confort y profesionalismo.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading text-lg text-white uppercase tracking-[0.2em] mb-6">
              Enlaces
            </h4>
            <div className="grid grid-cols-2 gap-3">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-gray-400 hover:text-[#3DD9E8] font-body text-sm transition-colors duration-200"
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-heading text-lg text-white uppercase tracking-[0.2em] mb-6">
              Redes Sociales
            </h4>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/turismo.puertodeseado"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center border border-white/10 hover:border-[#3DD9E8] hover:bg-[#3DD9E8]/10 transition-colors duration-200"
                data-testid="footer-facebook"
              >
                <Facebook className="text-white" size={20} />
              </a>
              <a
                href="https://www.instagram.com/puertodeseadoturismo"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center border border-white/10 hover:border-[#3DD9E8] hover:bg-[#3DD9E8]/10 transition-colors duration-200"
                data-testid="footer-instagram"
              >
                <Instagram className="text-white" size={20} />
              </a>
            </div>

            <div className="mt-8">
              <p className="text-gray-500 font-body text-xs">
                Suipacha 3659, B1650<br />
                Villa Juan Martin de Pueyrredon, Buenos Aires<br />
                Tel: 011 7078-0123<br />
                WhatsApp: +54 9 11 3763-1501<br />
                puertodeseadoviajes@gmail.com
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 font-body text-xs tracking-wider">
            &copy; {new Date().getFullYear()} Puerto Deseado Turismo SRL. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://www.machineagency.com.ar" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#3DD9E8] font-body text-sm tracking-wider transition-colors duration-200">by Machine Agency</a>
            <button
              onClick={scrollToTop}
              className="w-10 h-10 flex items-center justify-center border border-white/10 hover:border-[#D0162A] hover:bg-[#D0162A]/10 transition-colors duration-200"
              data-testid="scroll-to-top"
            >
              <ArrowUp className="text-white" size={18} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
